var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-stat"},[_c('img',{attrs:{"loading":"lazy","sizes":"100%, 100%","width":"auto","height":"30px","src":_vm.iconImage,"title":_vm.icon}}),_vm._v(" "),_c('span',{staticClass:"stat-value mt-1",class:_vm.contextClass},[_vm._v(_vm._s(_vm.boost > 0 ? '+':'')+_vm._s(_vm.value + _vm.boost))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-524a090c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/EquipmentStat.vue
// module id = null
// module chunks = 